import { Injectable } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en';

@Injectable({ providedIn: 'root' })
export class SessionService {

    private _locale: string = '';
    private _culture: string = '';

    set locale(value: string) {
        this._locale = value;
    }
    get locale(): string {
        return this._locale || 'it-IT';
    }




    registerCulture(culture: string) {
        if (!culture) {
            return;
        }
        this.locale = culture;

        // Register locale data since only the en-US locale data comes with Angular
        switch (culture) {
            case 'it-IT': {
                registerLocaleData(localeIt);
                this._culture = culture;
                break;
            }
            case 'en-EN': {
              registerLocaleData(localeEn);
              this._culture = culture;
              break;
          }

        }
    }
}
